<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="600px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ method === "post" ? "Add" : "Edit" }} Campaign</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <custom-form
          :fields="{ ...campaign }"
          :method="method"
          :action="url"
          @submitted="submittedSuccessfully"
        >
          <v-container>
            <v-row>
              <v-col cols="6">
                <custom-input name="name" label="Campaign name" />
              </v-col>
              <v-col cols="6">
                <custom-input name="commercial_name" label="Commercial name" />
              </v-col>
              <v-col cols="4">
                <custom-select
                  :disabled="method == 'put'"
                  :items="target_users"
                  @changed="(value) => shouldShowUsers(value)"
                  name="target_users"
                  label="Target Users"
                />
              </v-col>
              <v-col cols="8" v-if="showUsers === true">
                <custom-user-search
                  name="target_user_ids"
                  label="Select the customer"
                  item_name="full_name"
                  item_value="id"
                  icon="mdi-account-search"
                  multiple
                />
              </v-col>
              <v-col cols="6">
                <custom-select
                  :disabled="method == 'put'"
                  @changed="(value) => (compensation_type = value)"
                  :items="compensation_types"
                  name="compensation_type"
                  label="Compensation Type"
                />
              </v-col>
            </v-row>
            <div v-show="compensation_type == 'euros'">
              <hr />
              <v-row>
                <v-col cols="6">
                  <custom-input
                    name="referrer_compensation_value"
                    type="number"
                    label="Referrer Compensation Value"
                  />
                </v-col>
                <v-col cols="6">
                  <custom-input
                    name="referred_compensation_value"
                    type="number"
                    label="Referred Compensation Value"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-checkbox label="Referrer Offer" v-model="addReferrerOffer"></v-checkbox>
                </v-col>
                <v-col cols="8" v-if="addReferrerOffer">
                  <custom-select
                    :items="offers"
                    name="referrer_offer_fee_configuration_id"
                    item-text="name"
                    item-value="id"
                    label="Referrer Offer"
                    :clearable="true"
                    v-model="campaign.referrer_offer_fee_configuration_id"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-checkbox label="Referred Offer" v-model="addReferredOffer"></v-checkbox>
                </v-col>
                <v-col cols="8" v-if="addReferredOffer">
                  <custom-select
                    :items="offers"
                    name="referred_offer_fee_configuration_id"
                    item-text="name"
                    item-value="id"
                    label="Referred Offer"
                    :clearable="true"
                    v-model="campaign.referred_offer_fee_configuration_id"
                  />
                </v-col>
              </v-row>
              <hr />
            </div>
            <v-row>
              <v-col cols="12" v-if="compensation_type !== 'euros'">
                <custom-select
                  @changed="(value) => (compensation_period = value)"
                  :items="compesation_periods"
                  name="compensation_period"
                  label="Compensation Period"
                />
              </v-col>
              <v-col
                cols="6"
                v-if="compensation_period === 'custom' && compensation_type !== 'euros'"
              >
                <custom-input
                  name="compensation_start_date"
                  label="Compensation Start Date (mm/dd/yyyy)"
                />
              </v-col>
              <v-col
                cols="6"
                v-if="compensation_period === 'custom' && compensation_type !== 'euros'"
              >
                <custom-input
                  name="compensation_end_date"
                  label="Compensation End Date (mm/dd/yyyy)"
                />
              </v-col>
              <v-col cols="6" v-if="compensation_type !== 'percentage'">
                <custom-input
                  :disabled="compensation_type === 'score' || compensation_type === 'percentage'"
                  name="min_referral_transfers"
                  type="number"
                  label="Min Referral Transfers"
                />
              </v-col>
              <v-col cols="6" v-if="compensation_type !== 'percentage'">
                <custom-input
                  :disabled="compensation_type === 'score' || compensation_type === 'percentage'"
                  name="min_referral_transfer_amount"
                  type="number"
                  label="Min Referral Transfer Amount"
                />
              </v-col>
              <v-col cols="6">
                <custom-input name="start_date" label="Campaign Start Date (mm/dd/yyyy)" />
              </v-col>
              <v-col cols="6">
                <custom-input name="end_date" label="Campaign End Date (mm/dd/yyyy)" />
              </v-col>
            </v-row>
          </v-container>
          <custom-button block color="primary">
            <v-icon>{{ method === "post" ? "mdi-plus" : "mdi-pencil" }} </v-icon>
            {{ method === "post" ? "Add" : "Edit" }} Campaign
          </custom-button>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from "moment";
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    campaign: {
      default: () => ({ min_referral_transfers: 1, min_referral_transfer_amount: 50 }),
      type: Object,
    },
  },
  data() {
    return {
      compensation_types: [
        { value: "euros", text: "Euros" },
        { value: "score", text: "Score" },
        { value: "percentage", text: "Percentage" },
      ],
      compesation_periods: [
        { value: "1 month", text: "1 month" },
        { value: "6 month", text: "6 Month" },
        { value: "1 year", text: "1 year" },
        { value: "custom", text: "Custom" },
      ],
      target_users: ["customers", "admin", "influencers", "custom"],
      compensation_type: "",
      compensation_period: "custom",
      addReferrerOffer: false,
      addReferredOffer: false,
      showUsers: false,
      offers: [],
    };
  },
  computed: {
    url() {
      if (this.campaign.id) {
        return `/api/v1/campaigns/${this.campaign.id}`;
      }
      return `/api/v1/campaigns`;
    },
  },
  mounted() {
    if (this.method === "put" || this.method === "PUT") {
      this.compensation_type = this.campaign.compensation_type;
      this.compensation_period = this.campaign.compensation_period;
      this.campaign.start_date = moment(this.campaign.start_date).format("MM/DD/YYYY");
      this.campaign.end_date = moment(this.campaign.end_date).format("MM/DD/YYYY");
    }
    if (
      typeof this.campaign.referrer_offer_fee_configuration_id === "string" &&
      this.campaign.referrer_offer_fee_configuration_id.length > 0
    )
      this.addReferrerOffer = true;
    if (
      typeof this.campaign.referred_offer_fee_configuration_id === "string" &&
      this.campaign.referred_offer_fee_configuration_id.length > 0
    )
      this.addReferredOffer = true;
  },
  created() {
    this.$http
      .get("/api/v1/campaigns-transfer-offers")
      .then((response) => (this.offers = response));
  },
  methods: {
    shouldShowUsers(value) {
      this.showUsers = false;
      if (value === "custom") {
        this.showUsers = true;
      }
    },
    submittedSuccessfully(event) {
      if (this.method === "post") {
        this.$emit("added", event);
        return;
      }
      this.$emit("edited", event);
    },
  },
  watch: {},
};
</script>
